import { Component } from '@angular/core';
import { GenericCrudEditComponent } from 'src/app/libs/components/generic-crud/generic-crud-edit.component';
import { ProductBatchState } from 'src/app/models';

@Component({
    selector: 'app-product-batch-states-edit',
    templateUrl: './product-batch-states-edit.component.html',
    styleUrl: './product-batch-states-edit.component.sass',
    standalone: false
})
export class ProductBatchStatesEditComponent extends GenericCrudEditComponent<ProductBatchState> {
  override resource = this.api.resources.product.productBatchStates;
  displayEntity = () => this.entity!.name;
  initFormGroup() {
    const form = this.fb.group({
      id: [this.entity!.id],
      name: [this.entity!.name],
      color: [this.entity!.color ?? ''],
      companyId: [this.entity!.companyId],
      excludeFromStockForecast: [this.entity!.excludeFromStockForecast],
      excludeFromValuedInventory: [this.entity!.excludeFromValuedInventory],
      isBlockedForOperations: [this.entity!.isBlockedForOperations],
    });
    return form;
  }

  protected override async mapFormEntity(): Promise<Partial<ProductBatchState>> {
    const v = { ...this.form!.value } as Partial<ProductBatchState>;
    return { ...v, color: v.color ?? '' };
  }
}
